import React from 'react';
import {ErrorBoundary} from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";
import TeacherHomePageBody from "root/TeacherHomePageBody";
import './HomePage.scss' ;
const HomePage = (props) =>
{
    return (
        <ErrorBoundary  FallbackComponent={FallbackComponent}>
            <TeacherHomePageBody/>
        </ErrorBoundary>
    )
}

export default HomePage;
